import {
  CustomPriceListSortOption,
  enumCustomPriceListSortOption,
} from '@rematter/frontend-lib-api-client';
import { atom } from 'jotai';

import {
  customPriceListDeleteAtom,
  customPriceListDraftAtom,
} from '../_graphql/mutationCustomPriceListLifecycle';
import { customPriceListsListQueryAtom } from '../_graphql/queryCustomPriceListsList';
import { customPriceListStatusCountsQueryAtom } from '../_graphql/queryCustomPriceListStatusCounts';
import { CustomPriceListStatus } from '../types/pricing';

import { atomFromQueryString } from '~/shared/state';

export const $limit = atomFromQueryString.number('cllimit', 50);
export const $offset = atomFromQueryString.number('cloffset', 0);
export const $statusFilter =
  atomFromQueryString.string<CustomPriceListStatus>('clstatus');

export const $isCreateDialogOpen = atom<boolean>(false);
export const $currentSorting = atom<CustomPriceListSortOption[]>([
  enumCustomPriceListSortOption.CreatedAtDesc,
]);

const deriveServerFilters = (
  status: CustomPriceListStatus | '',
): { isPublished?: boolean; isArchived?: boolean } => {
  switch (status) {
    case 'Draft':
      return { isPublished: false, isArchived: false };
    case 'Active':
    case 'Expired':
      return { isPublished: true, isArchived: false };
    case 'Archived':
      return { isArchived: true };
    default:
      return {};
  }
};

export const $remoteCustomPriceLists = customPriceListsListQueryAtom((get) => {
  const limit = get($limit);
  const offset = get($offset);
  const sorting = get($currentSorting);
  const statusFilter = get($statusFilter);
  const serverFilters = deriveServerFilters(statusFilter);

  return {
    variables: {
      ...serverFilters,
      limit,
      offset,
      sorting,
    },
  };
});

export const $remoteStatusCounts = customPriceListStatusCountsQueryAtom();

export const $draftCustomPriceList = customPriceListDraftAtom({
  onSuccess: (get) => {
    get($remoteCustomPriceLists).refetch?.();
    get($remoteStatusCounts).refetch?.();
  },
});

export const $deleteCustomPriceList = customPriceListDeleteAtom({
  onSuccess: (get) => {
    get($remoteCustomPriceLists).refetch?.();
    get($remoteStatusCounts).refetch?.();
  },
});
